type Day = "sunday" | "monday" | "tuesday" | "wednesday" | "thursday" | "friday" | "saturday";

export type DayOfWeek = {
  [key in Day]: number;
};

export function toDow(onEventKeys: string[]): DayOfWeek {
  function dow(week: Day[]): number {
    if (onEventKeys.length === 0) return 0;
    return week.findIndex((d) => onEventKeys.includes(d));
  }

  return {
    sunday: dow(["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"]),
    monday: dow(["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"]),
    tuesday: dow(["tuesday", "wednesday", "thursday", "friday", "saturday", "sunday", "monday"]),
    wednesday: dow(["wednesday", "thursday", "friday", "saturday", "sunday", "monday", "tuesday"]),
    thursday: dow(["thursday", "friday", "saturday", "sunday", "monday", "tuesday", "wednesday"]),
    friday: dow(["friday", "saturday", "sunday", "monday", "tuesday", "wednesday", "thursday"]),
    saturday: dow(["saturday", "sunday", "monday", "tuesday", "wednesday", "thursday", "friday"]),
  };
}
